import { useState } from 'react';
import { Typography, IconButton } from '@mui/material';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5';
import { ZoomIn, ZoomOut, Close } from '@mui/icons-material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DownloadIcon from '@mui/icons-material/Download';

export default function PDFViewerV2(props) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);

  function handleZoomIn(event) {
    event.preventDefault();
    setScale(prevScale => prevScale + 0.2);
  }

  function handleZoomOut(event) {
    event.preventDefault();
    setScale(prevScale => Math.max(prevScale - 0.2, 0.5));
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    const newPageNumber = pageNumber + offset;
    if (newPageNumber > 0 && newPageNumber <= numPages)
      setPageNumber(newPageNumber);
  }

  function handleDownload() {
    const linkSource = `data:application/pdf;base64,${props.document}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = props.title;
    downloadLink.click();
  }

  function handleClose(event) {
    props.clicDoc(event, null, props.title);
  }


  return (
    <>
      <div style={{ textAlign: 'center' }}>
        <Typography variant="h6">{props.title}</Typography>
      </div>

      {/* Controlli per zoom, navigazione e chiusura */}
      <div style={{ textAlign: 'center', marginBottom: '10px' }}>
        <IconButton onClick={() => changePage(-1)} disabled={pageNumber <= 1}>
          <PlayArrowIcon sx={{ transform: 'scaleX(-1)' }} />
        </IconButton>

        <IconButton onClick={handleZoomOut}>
          <ZoomOut />
        </IconButton>

        <IconButton onClick={handleDownload}>
          <DownloadIcon />
        </IconButton>

        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>

        <IconButton onClick={handleZoomIn}>
          <ZoomIn />
        </IconButton>

        <IconButton onClick={() => changePage(1)} disabled={pageNumber >= numPages}>
          <PlayArrowIcon />
        </IconButton>
      </div>

      {/* Contenitore con scrollbar e centratura del PDF */}
      <div
        style={{
          width: '100%',
          height: '60vh',
          overflow: 'auto',
          display: 'flex',
          justifyContent: 'center',  // Centra orizzontalmente
          alignItems: 'flex-start',  // Centra verticalmente
          backgroundColor: '#f5f5f5',
        }}
      >
        <Document
          file={`data:application/pdf;base64,${props.document}`}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Page
            pageNumber={pageNumber}
            scale={scale}
          />
        </Document>
      </div>

      {/* Paginazione */}
      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <Typography variant="caption">
          Pagina {pageNumber} di {numPages}
        </Typography>
      </div>
    </>
  );
}
